import { useEventBus } from "@vueuse/core";
import type { ProductGroup } from "../domain/productGroup";

export function useProductGroupChanged() {
  return useEventBus<ProductGroupChanged>("product-group-changed");
}

export type ProductGroupChanged = ProductGroupUpdated | ProductGroupRemoved;

export interface ProductGroupUpdated {
  id: string;
  action: 'updated';
  data: ProductGroup;
}

export interface ProductGroupRemoved {
  id: string;
  action: 'removed'
}
